import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FolderClock, ShieldX } from 'lucide-react';
import { crmAPI, useCRMAuth } from '../context/CRMAuthContext';

export const CRMRoute = ({ moduleId, children, record }) => {
  const { user } = useCRMAuth();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let active = true;
    setState({ loading: true });
    const load = async () => {
      try {
        const { data } = await crmAPI.get(`/modules/${moduleId}`);
        if (record) await crmAPI.get(record);
        if (active) setState({ data });
      } catch (e) { if (active) setState({ error: e.response?.status === 404 ? 'Kayıt bulunamadı.' : e.response?.status === 403 ? 'Yetkisiz erişim.' : 'Sayfa yüklenemedi.' }); }
    };
    load(); return () => { active = false; };
  }, [moduleId, record, user?.role, JSON.stringify(user?.permissions)]);
  if (state.loading) return <div className="crm-empty" data-testid="crm-route-loading">Yükleniyor…</div>;
  if (state.error) return <div className="crm-empty crm-access-denied" role="alert" data-testid="crm-route-denied"><ShieldX size={34} /><h1 data-testid={`crm-${moduleId}-access-denied-message`}>{state.error}</h1><Link to="/crm" data-testid="crm-denied-home">Genel Görünüme Dön</Link></div>;
  if (children) return children;
  return <section data-testid={`crm-placeholder-${moduleId}`}><div className="crm-page-heading"><div><p className="crm-eyebrow">ÇALIŞMA ALANI</p><h1>{state.data.label}</h1></div><span className="crm-planned-badge">Sonraki aşama</span></div><div className="crm-placeholder"><FolderClock size={42} strokeWidth={1.25} /><h2>{state.data.label}</h2><p data-testid="crm-placeholder-message">Bu modül sonraki aşamada aktif edilecektir.</p></div></section>;
};